import React, { useState } from 'react';
export const ClaimAssessment = ({
  assessment
}) => {
  const [showCitations, setShowCitations] = useState(false);
  const [activeIngredient, setActiveIngredient] = useState(null);
  const [activeTab, setActiveTab] = useState({});
  const getComplianceStatus = status => {
    switch (status) {
      case 'Compliant':
        return <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-100" data-id="element-44">
            <span className="mr-1 w-2 h-2 rounded-full bg-green-500" data-id="element-45"></span>
            Compliant
          </span>;
      case 'Non-Compliant':
        return <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-100" data-id="element-46">
            <span className="mr-1 w-2 h-2 rounded-full bg-red-500" data-id="element-47"></span>
            Issues Found
          </span>;
      case 'Needs Revision':
        return <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-50 text-yellow-700 border border-yellow-100" data-id="element-48">
            <span className="mr-1 w-2 h-2 rounded-full bg-yellow-500" data-id="element-49"></span>
            Under Review
          </span>;
      default:
        return <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-50 text-gray-700 border border-gray-100" data-id="element-50">
            <span className="mr-1 w-2 h-2 rounded-full bg-gray-500" data-id="element-51"></span>
            {status}
          </span>;
    }
  };
  const getRiskIndicator = risk => {
    switch (risk) {
      case 'LOW':
        return <span className="inline-block w-3 h-3 rounded-full bg-green-500" data-id="element-52"></span>;
      case 'MEDIUM':
        return <span className="inline-block w-3 h-3 rounded-full bg-yellow-500" data-id="element-53"></span>;
      case 'HIGH':
        return <span className="inline-block w-3 h-3 rounded-full bg-red-500" data-id="element-54"></span>;
      default:
        return <span className="inline-block w-3 h-3 rounded-full bg-gray-500" data-id="element-55"></span>;
    }
  };
  const toggleCitations = () => {
    setShowCitations(!showCitations);
  };
  const toggleIngredient = ingredientName => {
    if (activeIngredient === ingredientName) {
      setActiveIngredient(null);
    } else {
      setActiveIngredient(ingredientName);
    }
  };
  const handleTabChange = (ingredient, tab) => {
    setActiveTab(prev => ({
      ...prev,
      [ingredient]: tab
    }));
  };
  // Get citations count for an ingredient
  const getIngredientCitationsCount = ingredientName => {
    return assessment.citations.filter(citation => citation.ingredient === ingredientName).length;
  };
  // Filter citations by ingredient if one is selected
  const filteredCitations = activeIngredient ? assessment.citations.filter(citation => citation.ingredient === activeIngredient) : assessment.citations;
  return <div className="mb-6 ml-11 max-w-3xl bg-white border rounded-lg overflow-hidden shadow-sm" data-id="element-56">
      <div className="p-5" data-id="element-57">
        <div className="flex justify-between items-center mb-4" data-id="element-58">
          <div className="flex items-center gap-2" data-id="element-59">
            <h3 className="text-sm font-medium uppercase text-gray-500" data-id="element-60">
              Claim Assessment
            </h3>
            <div className="flex items-center gap-2" data-id="element-61">
              {getRiskIndicator(assessment.riskLevel)}
              <span className="text-sm font-medium" data-id="element-62">
                {assessment.riskLevel} RISK
              </span>
            </div>
          </div>
          {getComplianceStatus(assessment.complianceStatus)}
        </div>
        <div className="mb-4" data-id="element-63">
          <h2 className="text-lg font-medium mb-1" data-id="element-64">"{assessment.claim}"</h2>
          <p className="text-sm text-gray-600" data-id="element-65">{assessment.issues}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-66">
          <div className="space-y-4" data-id="element-67">
            <h4 className="text-sm font-medium uppercase text-gray-500" data-id="element-68">
              Evidence Summary
            </h4>
            <div className="space-y-2" data-id="element-69">
              <div className="flex justify-between" data-id="element-70">
                <span className="text-sm text-gray-600" data-id="element-71">
                  Supporting Studies
                </span>
                <span className="text-sm font-medium" data-id="element-72">
                  {assessment.supportingStudies}
                </span>
              </div>
              <div className="flex justify-between" data-id="element-73">
                <span className="text-sm text-gray-600" data-id="element-74">Evidence Strength</span>
                <span className="text-sm font-medium" data-id="element-75">
                  {assessment.evidenceStrength}
                </span>
              </div>
            </div>
            <h4 className="text-sm font-medium uppercase text-gray-500" data-id="element-76">
              Key Ingredients
            </h4>
            <div className="space-y-1" data-id="element-77">
              {assessment.keyIngredients.map((ingredient, index) => <div key={index} className={`text-sm py-1 px-2 rounded-md cursor-pointer ${activeIngredient === ingredient ? 'bg-purple-100 text-purple-800' : 'hover:bg-gray-100'}`} onClick={() => toggleIngredient(ingredient)} data-id="element-78">
                  {ingredient}
                </div>)}
              {activeIngredient && <button className="text-xs text-purple-600 mt-2 hover:underline" onClick={() => setActiveIngredient(null)} data-id="element-79">
                  Clear filter
                </button>}
            </div>
          </div>
          <div className="space-y-4" data-id="element-80">
            <h4 className="text-sm font-medium uppercase text-gray-500" data-id="element-81">
              Regulatory Issues
            </h4>
            <div className="space-y-1" data-id="element-82">
              {assessment.regulatoryIssues.map((issue, index) => <div key={index} className="text-sm flex items-start gap-2" data-id="element-83">
                  <span className="text-red-500 mt-1" data-id="element-84">•</span>
                  <span data-id="element-85">{issue}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
      {assessment.citations && <div className="border-t p-5" data-id="element-86">
          <div className="flex items-center justify-between w-full mb-3" data-id="element-87">
            <h4 className="text-sm font-medium uppercase text-gray-500" data-id="element-88">
              Citations {activeIngredient ? `for ${activeIngredient}` : ''} (
              {filteredCitations.length})
            </h4>
            <div className="flex items-center gap-2" data-id="element-89">
              <div className="relative" data-id="element-90">
                <select className="appearance-none bg-white border rounded-md py-1 pl-3 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-[#6A36FC]" value={activeIngredient || ''} onChange={e => setActiveIngredient(e.target.value || null)} data-id="element-91">
                  <option value="" data-id="element-92">All Ingredients</option>
                  {assessment.keyIngredients.map((ingredient, index) => <option key={index} value={ingredient} data-id="element-93">
                      {ingredient}
                    </option>)}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" data-id="element-94">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-95">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-96"></path>
                  </svg>
                </div>
              </div>
              <button onClick={toggleCitations} className="p-1 rounded hover:bg-gray-100" aria-label={showCitations ? 'Hide citations' : 'Show citations'} data-id="element-97">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`transition-transform ${showCitations ? 'transform rotate-180' : ''}`} data-id="element-98">
                  <polyline points="6 9 12 15 18 9" data-id="element-99"></polyline>
                </svg>
              </button>
            </div>
          </div>
          {showCitations && <div className="mt-3 space-y-3 max-h-[300px] overflow-y-auto" data-id="element-100">
              {filteredCitations.map((citation, index) => <div key={index} className="p-3 bg-gray-50 rounded-md border text-sm" data-id="element-101">
                  <div className="font-medium mb-1" data-id="element-102">
                    {citation.author} ({citation.year})
                  </div>
                  <div className="mb-2 italic" data-id="element-103">{citation.title}</div>
                  <div className="text-gray-600 mb-2" data-id="element-104">{citation.journal}</div>
                  <div className="flex items-center justify-between" data-id="element-105">
                    <a href={citation.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-[#6A36FC] hover:underline" data-id="element-106">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-107">
                        <path d="M12 2H2v10h10V2Z" data-id="element-108" />
                        <path d="M12 2h10v10H12V2Z" data-id="element-109" />
                        <path d="M22 22H2V12h20v10Z" data-id="element-110" />
                      </svg>
                      View PDF
                    </a>
                    <span className="text-xs bg-purple-50 text-purple-700 px-2 py-1 rounded-full" data-id="element-111">
                      {citation.ingredient}
                    </span>
                  </div>
                </div>)}
            </div>}
        </div>}
      <div className="border-t p-5" data-id="element-112">
        <h4 className="text-sm font-medium uppercase text-gray-500 mb-3" data-id="element-113">
          Recommended Claim Alternatives
        </h4>
        <div className="mb-3 p-3 bg-green-50 rounded-md border border-green-100" data-id="element-114">
          <div className="text-xs font-medium text-green-800 mb-1" data-id="element-115">
            LOW RISK VERSION
          </div>
          <p className="text-sm" data-id="element-116">"{assessment.recommendedClaim}"</p>
        </div>
        {assessment.enhancedClaim && <div className="p-3 bg-purple-50 rounded-md border border-purple-100" data-id="element-117">
            <div className="text-xs font-medium text-purple-800 mb-1" data-id="element-118">
              ENHANCED VERSION
            </div>
            <p className="text-sm" data-id="element-119">"{assessment.enhancedClaim}"</p>
          </div>}
      </div>
      <div className="border-t p-5" data-id="element-120">
        <h4 className="text-sm font-medium uppercase text-gray-500 mb-3" data-id="element-121">
          Evidence by Ingredient
        </h4>
        <div className="space-y-4" data-id="element-122">
          {assessment.ingredients.map((ingredient, index) => {
          const ingredientCitations = assessment.citations.filter(citation => citation.ingredient === ingredient.name);
          const citationsCount = ingredientCitations.length;
          const currentTab = activeTab[ingredient.name] || 'details';
          return <div key={index} className="rounded-md border overflow-hidden" data-id="element-123">
                <div className="bg-gray-50 p-3 font-medium" data-id="element-124">
                  {ingredient.name} ({ingredient.dosage})
                </div>
                <div className="flex border-b" data-id="element-125">
                  <button className={`flex-1 py-2 px-4 text-sm font-medium ${currentTab === 'details' ? 'bg-white text-[#6A36FC] border-b-2 border-[#6A36FC]' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'}`} onClick={() => handleTabChange(ingredient.name, 'details')} data-id="element-126">
                    Details
                  </button>
                  <button className={`flex-1 py-2 px-4 text-sm font-medium flex items-center justify-center gap-2 ${currentTab === 'citations' ? 'bg-white text-[#6A36FC] border-b-2 border-[#6A36FC]' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'}`} onClick={() => handleTabChange(ingredient.name, 'citations')} data-id="element-127">
                    Citations
                    {citationsCount > 0 && <span className={`inline-flex items-center justify-center w-5 h-5 text-xs rounded-full ${currentTab === 'citations' ? 'bg-[#6A36FC] text-white' : 'bg-gray-200 text-gray-700'}`} data-id="element-128">
                        {citationsCount}
                      </span>}
                  </button>
                </div>
                <div className="p-3 bg-white" data-id="element-129">
                  {currentTab === 'details' ? <div className="text-sm space-y-3" data-id="element-130">
                      <div className="space-y-1" data-id="element-131">
                        <div className="flex items-start" data-id="element-132">
                          <span className="font-medium w-20" data-id="element-133">Evidence:</span>
                          <span data-id="element-134">{ingredient.evidence}</span>
                        </div>
                        <div className="flex items-start" data-id="element-135">
                          <span className="font-medium w-20" data-id="element-136">Role:</span>
                          <span data-id="element-137">{ingredient.role}</span>
                        </div>
                      </div>
                      {ingredient.claims && ingredient.claims.length > 0 && <div data-id="element-138">
                          <div className="text-xs font-medium text-gray-500 mb-2" data-id="element-139">
                            SUPPORTED CLAIMS
                          </div>
                          <div className="space-y-1" data-id="element-140">
                            {ingredient.claims.map((claim, claimIndex) => <div key={claimIndex} className="text-sm flex items-start gap-2" data-id="element-141">
                                <span className="text-purple-500 mt-1" data-id="element-142">•</span>
                                <span data-id="element-143">{claim}</span>
                              </div>)}
                          </div>
                        </div>}
                    </div> : <div className="space-y-3" data-id="element-144">
                      {ingredientCitations.length > 0 ? ingredientCitations.map((citation, citIndex) => <div key={citIndex} className="text-sm border-b pb-3 last:border-b-0 last:pb-0" data-id="element-145">
                            <div className="font-medium mb-1" data-id="element-146">
                              {citation.author} ({citation.year})
                            </div>
                            <div className="mb-2 italic text-sm" data-id="element-147">
                              {citation.title}
                            </div>
                            <div className="text-gray-600 text-sm mb-2" data-id="element-148">
                              {citation.journal}
                            </div>
                            <a href={citation.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-sm text-[#6A36FC] hover:underline" data-id="element-149">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-150">
                                <path d="M12 2H2v10h10V2Z" data-id="element-151" />
                                <path d="M12 2h10v10H12V2Z" data-id="element-152" />
                                <path d="M22 22H2V12h20v10Z" data-id="element-153" />
                              </svg>
                              View PDF
                            </a>
                          </div>) : <div className="text-sm text-gray-500 italic" data-id="element-154">
                          No citations available
                        </div>}
                    </div>}
                </div>
              </div>;
        })}
        </div>
      </div>
    </div>;
};